export const ONBOARDING_TITLE_LINE_1 = 'Browse for 30 seconds,';
export const getOnboardingTitleLine2 = (credit: string): string => `Earn ${credit} credit!`;

export const ONBOARDING_HOW_IT_WORKS = 'How it works';

export const ONBOARDING_BULLETS = [
  'Get rewarded every 30 seconds you browse',
  'Earn credit multiple times a day',
  'Keep exploring to earn more',
] as const;

export const ONBOARDING_NOTE_TITLE = 'PLEASE NOTE';

export const ONBOARDING_NOTE_BULLETS = [
  'Credit is earned once per browsing session',
  'Session resets after a period of inactivity',
] as const;

export const ONBOARDING_CTA_TEXT = 'Keep browsing & earn credit';
